module.exports = __webpack_public_path__ + "img/wallet.282c60e6.svg";